import { render, staticRenderFns } from "./ContentMetadata.vue?vue&type=template&id=4c2143a6&scoped=true"
import script from "./ContentMetadata.vue?vue&type=script&lang=js"
export * from "./ContentMetadata.vue?vue&type=script&lang=js"
import style0 from "./ContentMetadata.vue?vue&type=style&index=0&id=4c2143a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2143a6",
  null
  
)

export default component.exports